{
  "combobox": {
    "clearAll": "Fjern alle valg",
    "toggleDropdown": "Åpne/lukk nedtrekksliste"
  },
  "organizationSearchField": {
    "removeOrganization": "Fjern organisasjon",
    "searching": "Søker etter organisasjon..."
  }
}
